import { STORAGE_KEY_SESSION_EXPIRES_AT, STORAGE_KEY_SESSION_RECOVERY_PENDING } from '@/constants/storage';
import { localStore } from '@/utils/storage';

/** 本地有效期仅参与请求调度，实际鉴权仍由 httpOnly cookie 完成。 */
export function readSessionExpiresAt(): number | null {
    const raw = localStore.getItem(STORAGE_KEY_SESSION_EXPIRES_AT);
    if (raw === null || raw.trim() === '') {
        return null;
    }
    const expiresAt = Number(raw);
    return Number.isFinite(expiresAt) ? expiresAt : null;
}

/** localStore 会吞写入异常，需读回确认，不能用假有效期放行业务。 */
export function saveSessionExpiry(remainingSeconds: number): boolean {
    const expiresAt = Date.now() + remainingSeconds * 1000;
    localStore.setItem(STORAGE_KEY_SESSION_EXPIRES_AT, String(expiresAt));
    return readSessionExpiresAt() === expiresAt;
}

export function markSessionRecoveryPending(): boolean {
    localStore.setItem(STORAGE_KEY_SESSION_RECOVERY_PENDING, '1');
    return localStore.getItem(STORAGE_KEY_SESSION_RECOVERY_PENDING) === '1';
}

export function clearSessionRecoveryPending(): boolean {
    localStore.removeItem(STORAGE_KEY_SESSION_RECOVERY_PENDING);
    return localStore.getItem(STORAGE_KEY_SESSION_RECOVERY_PENDING) === null;
}
